import { login, logout, getInfo, signup } from '@/api/login'
import { fetchBranchList, fetchCarList,fetchWtUnit,fetchGate, fetchMenuList } from '@/api/gate_data'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
    state: {
        token: getToken(),
        name: '',
        role: null,
        roleId: null,
        userId: null,
        branches: [],
        menus: [],
        gate: null,
        branch: null,
        companyName: null,
        cars: [],
        miniCars: [],
        wtUnits: [],
        gates: [],
        menus: [],
        gateBranches: [],
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_NAME: (state, name) => {
            state.name = name
        },
        SET_ROLE: (state, role) => {
            state.role = role
        },
        SET_ROLE_ID: (state,roleId) => {
            state.roleId = roleId
        },
        SET_USER_ID: (state, userId) => {
            state.userId = userId
        },
        SET_BRANCHES: (state, branches) => {
            state.branches = branches
        },
        SET_COMPANY_NAME: (state, companyName) => {
            state.companyName = companyName
        },
        SET_GATE: (state, gate) => {
            state.gate = gate
        },
        SET_BRANCH: (state, branch) => {
            state.branch = branch
        },
        SET_MENUS: (state, menus) => {
            state.menus = menus
        },
        SET_CARS: (state, cars) => {
            state.cars = cars
        },
        SET_MINI_CARS: (state, cars) => {
            state.miniCars = cars
        },
        SET_WTUNITS: (state, wtUnits) => {
            state.wtUnits = wtUnits
        },
        SET_MENUS: (state, menus) => {
            state.menus = menus
        },
        SET_GATES: (state, gates) => {
            state.gates = gates
        },
        SET_GATE_BRANCHES: (state, gateBranches) => {
            state.gateBranches = gateBranches
        }
    },
    actions: {
        async  Login({ commit }, userInfo) {
            try{
                const username = userInfo.username.trim()
                const response = await login(username, userInfo.password)
                const data = response.data
                const tokenStr = "Bearer "+data.token
                setToken(tokenStr)
                commit('SET_TOKEN', tokenStr)
                const getInfo = await this.dispatch('GetInfo')
                // const menus = getInfo.data.menus
                // await this.dispatch('GenerateRoutes', { menus })

                return getInfo;
            }catch(error){
                throw error
            }
        },
        SignUp({ commit }, userInfo) {
            const username = userInfo.username.trim()
            const password = userInfo.password.trim()
            const name = userInfo.name.trim();
            return new Promise((resolve, reject) => {
                signup(username, password, name).then(() => {
                    // commit('SET_TOKEN', '')
                    // commit('SET_ROLES', [])
                    // removeToken()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        async GetInfo({ commit }) {
            try {
                const response = await getInfo()
                const data = response.data

                // Validate roleName
                if (!data.roleName) {
                    throw new Error('getInfo: roleName must be a non-null string!')
                }

                // Commit basic user info
                commit('SET_ROLE', data.roleName)
                commit('SET_ROLE_ID', data.roleId)
                commit('SET_NAME', data.name)
                commit('SET_USER_ID', data.id)
                commit('SET_MENUS', data.menus || [])

                // Commit branches and menus (fallback to [])
                if(data.roleId != 1){
                    const branches = data.branches || []
                    commit('SET_BRANCHES', branches)

                    // Handle company & branch logic
                    if (branches.length === 1) {
                        const branch = branches[0]
                        commit('SET_BRANCH', branch)
                        commit('SET_COMPANY_NAME', `${branch.gateName} (${branch.name})`)
                    } else if (branches.length > 1) {
                        commit('SET_COMPANY_NAME', branches[0]?.gateName || '')
                    } else {
                        commit('SET_COMPANY_NAME', '')
                    }
                    const [ carsResponse, wtUnitsResponse, branchResponse ] = await Promise.all([
                        fetchCarList({gateId: branches[0]?.gateId}),
                        fetchWtUnit(),
                        fetchBranchList({gateId: branches[0]?.gateId})
                    ])

                    const gate = {
                        gateId: data.gateId,
                        gateName: data.gateName,
                        gateDescription: data.gateDescription,
                        gatePolicy: data.gatePolicy,
                        editableWindowDays: data.editableWindowDays,
                    }

                    commit('SET_GATE', gate)
                    commit('SET_CARS', carsResponse.data.filter(car => car.isMini === 0))
                    commit('SET_MINI_CARS', carsResponse.data.filter(car => car.isMini === 1))
                    commit('SET_WTUNITS', wtUnitsResponse.data)
                    commit('SET_GATE_BRANCHES', branchResponse.data)
                    
                }
                else{
                    const [ gateRes, menuRes ] = await Promise.all([
                        fetchGate(),
                        fetchMenuList(),
                    ])


                    commit('SET_GATES', gateRes.data)
                    commit('SET_MENUS', menuRes.data)
                }
               
                return response
            } catch (error) {
                throw error
            }
        },
        SetCars({commit}, cars){
            commit('SET_CARS', cars.filter(car => car.isMini === 0))
            commit('SET_MINI_CARS', cars.filter(car => car.isMini === 1))
        },

        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
               commit('SET_TOKEN', '')
               commit('SET_ROLE', null)
               commit('SET_ROLE_ID', null)
               removeToken()
               resolve()
            })
        },

        FedLogOut({ commit }) {
            return new Promise(resolve => {
                commit('SET_TOKEN', '')
                removeToken()
                resolve()
            })
        }
    }
}

export default user
